// FAQ Schema data for all trade offer pages

export const faqSchemas = {
  plumber: {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How much does CRM software for plumbers cost?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Our Plumber Lifetime Upgrade costs £497/month (or $497/€497) with a 14-day trial for just £5. This includes unlimited leads, automated follow-up, booking system, SMS reminders, review automation, and full CRM features. Cancel anytime."
        }
      },
      {
        "@type": "Question",
        "name": "What's included in the 14-day trial?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "The £5 trial gives you full access to all Domination-tier features for 14 days, including automated lead capture, instant quote system, SMS appointment reminders, review request automation, customer management, and 24/7 booking widget. After 14 days, your monthly subscription begins automatically."
        }
      },
      {
        "@type": "Question",
        "name": "Will this work for my plumbing business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes! Our system is specifically designed for UK plumbers. Over 500 plumbing businesses use our platform to capture emergency calls, send instant quotes, reduce no-shows by 75%, and automate follow-up. It works whether you're a sole trader or have a team of plumbers."
        }
      },
      {
        "@type": "Question",
        "name": "How quickly can I get set up?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Most plumbers are up and running within 2 hours. Our guided setup wizard walks you through connecting your phone number, adding services, creating your booking page, and setting up automated messages. You can start capturing leads the same day."
        }
      },
      {
        "@type": "Question",
        "name": "Can I cancel anytime?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, you can cancel your subscription at any time with no penalties or cancellation fees. You'll retain access until the end of your current billing period."
        }
      },
      {
        "@type": "Question",
        "name": "Do I need technical skills to use this?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No technical skills required. Our platform is designed for busy tradespeople, not tech experts. Everything is point-and-click with templates ready to use. If you can use WhatsApp, you can use our system."
        }
      }
    ]
  },
  electrician: {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How much does CRM software for electricians cost?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Our Electrician Lifetime Upgrade costs £497/month (or $497/€497) with a 14-day trial for just £5. This includes unlimited leads, automated follow-up, booking system, SMS reminders, review automation, and full CRM features. Cancel anytime."
        }
      },
      {
        "@type": "Question",
        "name": "Will this help me get more electrical jobs?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes! Over 400 electricians use our platform and report 60-85% increases in booked jobs. Our system captures every enquiry 24/7, sends instant responses, automates follow-up, and reduces no-shows with SMS reminders. You never miss an opportunity again."
        }
      },
      {
        "@type": "Question",
        "name": "Can I send quotes through the system?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Absolutely. You can create quote templates for common jobs (rewiring, consumer units, EV chargers, etc.) and send professional quotes instantly. The system tracks when quotes are viewed and automatically follows up if they haven't responded."
        }
      },
      {
        "@type": "Question",
        "name": "Does it integrate with my calendar?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, the system includes a built-in booking calendar that syncs with Google Calendar. Customers can book available slots online, and you'll get automatic reminders. No more double-booking or phone tag."
        }
      },
      {
        "@type": "Question",
        "name": "What happens after the 14-day trial?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "After 14 days, your subscription continues at £497/month. You'll be automatically charged on your billing date. You can cancel anytime before then if it's not right for you - no questions asked."
        }
      }
    ]
  },
  roofer: {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How much does CRM software for roofers cost?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Our Roofer Lifetime Upgrade costs £497/month (or $497/€497) with a 14-day trial for just £5. This includes unlimited leads, automated follow-up, project management, SMS reminders, review automation, and full CRM features."
        }
      },
      {
        "@type": "Question",
        "name": "Can I manage large roofing projects with this?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes! The system includes project tracking, milestone management, payment scheduling, and customer communication for projects of any size - from small repairs to full re-roofs. Track materials, labour, and keep customers updated automatically."
        }
      },
      {
        "@type": "Question",
        "name": "Does it help with seasonal work planning?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Absolutely. You can send automated reminders for seasonal maintenance, create winter preparation campaigns, and nurture leads during slow periods. Over 300 roofers use our system to maintain steady work year-round."
        }
      },
      {
        "@type": "Question",
        "name": "Can I send estimates for roofing jobs?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, create estimate templates for different roof types and sizes, then customize and send professional quotes in minutes. Track which estimates convert and automatically follow up on pending quotes."
        }
      },
      {
        "@type": "Question",
        "name": "How does it help me get more Google reviews?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "After completing a job, the system automatically sends a review request at the perfect time. We've helped roofers increase their Google reviews from an average of 12 to over 150, dramatically improving their local search rankings."
        }
      }
    ]
  },
  hvac: {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How much does CRM software for HVAC engineers cost?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Our HVAC Lifetime Upgrade costs £497/month (or $497/€497) with a 14-day trial for just £5. This includes unlimited leads, automated service reminders, booking system, customer management, and maintenance scheduling."
        }
      },
      {
        "@type": "Question",
        "name": "Can I automate annual boiler service reminders?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes! The system automatically sends service reminders based on when the last service was completed. Set it once and never manually chase customers again. This feature alone helps HVAC businesses increase recurring revenue by 40%."
        }
      },
      {
        "@type": "Question",
        "name": "Does it work for both heating and cooling?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Absolutely. Manage boiler installations, repairs, servicing, air conditioning, heat pumps, and all HVAC services. Create different service packages and automate reminders specific to each system type."
        }
      },
      {
        "@type": "Question",
        "name": "Can customers book emergency callouts?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, your booking widget works 24/7 for emergency bookings. You can set emergency slots, premium pricing for out-of-hours, and get instant notifications. Never lose an emergency callout to a competitor again."
        }
      },
      {
        "@type": "Question",
        "name": "How does it help with seasonal demand?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Send automated campaigns for winter boiler checks, summer AC servicing, and pre-season maintenance. The system helps you fill your calendar during slow periods and manage peak season demand efficiently."
        }
      }
    ]
  },
  carpenter: {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How much does CRM software for carpenters cost?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Our Carpenter Lifetime Upgrade costs £497/month (or $497/€497) with a 14-day trial for just £5. This includes unlimited leads, project management, automated follow-up, booking system, and customer management."
        }
      },
      {
        "@type": "Question",
        "name": "Can I track multiple carpentry projects?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes! Track unlimited projects from small repairs to full renovations. Manage timelines, materials, milestones, and keep customers updated. Over 250 carpenters use our system to stay organized and never miss a deadline."
        }
      },
      {
        "@type": "Question",
        "name": "Does it help me win more bespoke projects?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Absolutely. Send professional quotes with image galleries of previous work, capture leads from your website 24/7, and automatically follow up with prospects. Carpenters report 60% higher conversion on high-value bespoke projects."
        }
      },
      {
        "@type": "Question",
        "name": "Can I manage my materials and suppliers?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, track materials needed per project, create supplier lists, and manage your inventory. This helps you order accurately and avoid costly delays or overstock."
        }
      },
      {
        "@type": "Question",
        "name": "Will this work for joinery and fitted furniture?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes! The system works for all carpentry specialties - fitted kitchens, bespoke furniture, staircases, decking, renovations, and general carpentry. Customize it to match your specific services."
        }
      }
    ]
  },
  landscaper: {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How much does CRM software for landscapers cost?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Our Landscaper Lifetime Upgrade costs £497/month (or $497/€497) with a 14-day trial for just £5. This includes unlimited leads, project management, seasonal reminders, booking system, and customer management."
        }
      },
      {
        "@type": "Question",
        "name": "Can I manage large garden projects?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes! Manage projects of any size from garden maintenance to complete landscape transformations. Track design approval, materials, planting schedules, and keep customers updated with photos throughout the project."
        }
      },
      {
        "@type": "Question",
        "name": "Does it help with seasonal maintenance contracts?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Absolutely. Automate seasonal reminders for lawn care, hedge trimming, spring planting, autumn clearance, and winter preparation. This helps you build recurring revenue - landscapers report 75% of customers becoming regulars."
        }
      },
      {
        "@type": "Question",
        "name": "Can I send landscaping quotes with images?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, create visual quotes with design mockups, before/after examples, and plant selections. The professional presentation helps you win more high-value projects and justify premium pricing."
        }
      },
      {
        "@type": "Question",
        "name": "How does it help during winter months?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Send automated campaigns for winter services (clearance, tree work, hard landscaping) and nurture leads for spring projects. Stay top-of-mind so when spring arrives, your calendar is already full."
        }
      }
    ]
  },
  painter: {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How much does CRM software for painters cost?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Our Painter & Decorator Lifetime Upgrade costs £497/month (or $497/€497) with a 14-day trial for just £5. This includes unlimited leads, project management, automated follow-up, booking system, and customer management."
        }
      },
      {
        "@type": "Question",
        "name": "Can I manage multiple painting jobs at once?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes! Track unlimited jobs from small room refreshes to full house redecorations. Manage preparation, painting schedules, touch-ups, and customer communication all in one place."
        }
      },
      {
        "@type": "Question",
        "name": "Does it help me win more decorating contracts?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Absolutely. Capture leads 24/7, send instant quotes, share before/after galleries, and automatically follow up. Over 400 painters report doubling their bookings and winning higher-value contracts."
        }
      },
      {
        "@type": "Question",
        "name": "Can I track colors and specifications per job?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, store paint colors, brands, finish types, and room specifications for each project. This makes touch-ups easy and helps with future maintenance work for returning customers."
        }
      },
      {
        "@type": "Question",
        "name": "Will this help me get steady work year-round?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes! Automate follow-ups for repeat work, send maintenance reminders, and nurture leads during slow periods. The review automation also helps you rank higher in local search, bringing in more enquiries."
        }
      }
    ]
  }
};

// Rating Schema - Use on all pages
export const aggregateRatingSchema = {
  "@context": "https://schema.org",
  "@type": "AggregateRating",
  "itemReviewed": {
    "@type": "SoftwareApplication",
    "name": "Local Business Heroes CRM",
    "applicationCategory": "BusinessApplication",
    "operatingSystem": "Web"
  },
  "ratingValue": "4.9",
  "bestRating": "5",
  "worstRating": "1",
  "ratingCount": "1247",
  "reviewCount": "1200"
};

// Generate individual review schema from testimonial
export const generateReviewSchema = (testimonial) => {
  return {
    "@context": "https://schema.org",
    "@type": "Review",
    "itemReviewed": {
      "@type": "SoftwareApplication",
      "name": "Local Business Heroes CRM"
    },
    "author": {
      "@type": "Person",
      "name": testimonial.name
    },
    "reviewRating": {
      "@type": "Rating",
      "ratingValue": testimonial.rating || 5,
      "bestRating": "5",
      "worstRating": "1"
    },
    "reviewBody": testimonial.text,
    "publisher": {
      "@type": "Organization",
      "name": "Local Business Heroes"
    }
  };
};
